// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a4f7f473","977":"00323907"}[chunkId] + ".chunk.js";
};